import _styled from "styled-components";
import React from "react";
import { hasItems } from "~/features/app/utils";
import { getThemeStyle, type Mode, type Theme } from "~/features/ui/get-theme-style";
export type ChipEvolutionGraphBulletPointsViewProps<TPoint> = {
  points?: readonly TPoint[] | null;
  theme: Theme;
  mode: Mode;
  getPointKey?: (point: TPoint, index: number) => React.Key;
  renderPoint: (point: TPoint, index: number) => React.ReactNode;
};
export function ChipEvolutionGraphBulletPointsView<TPoint>({
  points,
  theme,
  mode,
  getPointKey,
  renderPoint
}: ChipEvolutionGraphBulletPointsViewProps<TPoint>) {
  const themeStyle = getThemeStyle({
    mode,
    theme
  });
  if (!hasItems(points)) {
    return null;
  }
  return <_StyledUl $_css={[{
    "> :not([hidden]) ~ :not([hidden])": {
      "--tw-divide-y-reverse": "0",
      "borderTopWidth": "calc(1px * calc(1 - var(--tw-divide-y-reverse)))",
      "borderBottomWidth": "calc(1px * var(--tw-divide-y-reverse))"
    }
  }, {
    "> :not([hidden]) ~ :not([hidden])": {
      "--tw-divide-y-reverse": "0",
      "borderTopWidth": "calc(1px * calc(1 - var(--tw-divide-y-reverse)))",
      "borderBottomWidth": "calc(1px * var(--tw-divide-y-reverse))"
    }
  }, themeStyle.border]}>
      {points.map((point, idx) => <li key={getPointKey?.(point, idx) ?? idx}>{renderPoint(point, idx)}</li>)}
    </_StyledUl>;
}
var _StyledUl = /*#__PURE__*/_styled("ul").withConfig({
  displayName: "chip-evolution-graph-bullet-points___StyledUl",
  componentId: "sc-1bvo11r-0"
})(["", ""], p => p.$_css);